/*!
 * @monogrid/vue-boost v1.2.0 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
import n from "modernizr-esm/feature/a/download";
import u from "modernizr-esm/feature/blob";
import f from "modernizr-esm/feature/img/webp-alpha";
import m from "modernizr-esm/feature/img/webp-animation";
import p from "modernizr-esm/feature/img/webp-lossless";
import b from "modernizr-esm/feature/touchevents";
import c from "modernizr-esm/feature/url/bloburls";
import i from "modernizr-esm/feature/workers/transferables";
import w from "modernizr-esm/feature/workers/webworkers";
import { ref as e, computed as v } from "vue";
const l = document.createElement("audio");
l.volume = 0.5;
const t = {
  volume: e(l.volume === 0.5),
  adownload: e(n),
  webworkers: e(w),
  blobconstructor: e(u),
  bloburls: e(c),
  touchevents: e(b),
  webp: e(!1),
  "webp-alpha": e(!1),
  "webp-animation": e(!1),
  "webp-lossless": e(!1),
  transferables: e(!1)
}, h = async () => {
  t["webp-alpha"].value = t.webp.value = await f(), t["webp-animation"].value = await m(), t["webp-lossless"].value = await p(), t.transferables.value = await i();
};
h();
const L = (s) => {
  if (s) {
    const a = [];
    Object.keys(s).forEach((o) => {
      const r = s[o];
      typeof r == "boolean" ? t[o] = e(r) : typeof r == "function" && (t[o] = e(!1), a.push({ key: o, test: r }));
    }), a.forEach(async ({ key: o, test: r }) => {
      t[o].value = await r();
    });
  }
  return t;
}, S = (s, a) => v(() => {
  const o = {};
  return Object.keys(s).forEach((r) => {
    s[r].value === !0 ? o[r] = !0 : o[`no-${r}`] = !0;
  }), a !== !0 ? Object.keys(o).join(" ") : o;
});
export {
  L as default,
  L as useModernizr,
  S as useModernizrStyleClasses
};
